// import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Loader from "../../common/loader";
import { formatDateWithTime, formateDate, formateDateWithMonth, handleServerValidations } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Details } from "../../services/pendingappointment.service";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder } from "rsuite";
import { accociateUpdate, AssociateList } from "../../services/appointment.service";
import Swal from "sweetalert2";
import { SWAL_SETTINGS, THEME_COLORS } from "../../../../utils/Constants";

const PendingAppointmentLogsView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();

  const [data, setData] = useState("");
  const [showdefault, setShowDefault] = useState({});
  const [associateData, setAssociateData] = useState([]);
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("label_appointment_detail"),
      url: "/admin/pending-appointments/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    if (!params?._id) return;

    setLoading(true);
    Details({ _id: params._id })
      .then((response) => {
        const appointmentData = response?.data || {};
        setShowDefault(appointmentData);
        if (appointmentData?.associateData?._id) {
          setData(appointmentData.associateData._id);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("Details error:", error);
        setLoading(false);
      });
  }, [params._id]);


  if (loading) {
    return (
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <Loader />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">Log Details</h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0   && Object.keys(showdefault.logsArray).length > 0? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table className="table table-bordered table-hover" style={{ tableLayout: 'fixed', width: '100%' }}>
                      <colgroup>
                        <col style={{ width: '25%' }} />
                        <col style={{ width: '75%' }} />
                      </colgroup>
                      <tbody>
                        {
                          showdefault.logsArray.map((item)=>{
                           return( <tr>
                            <th className={item.type==='error'?"text-capitalize text-danger":"text-capitalize"}>Step:{item.step}</th>
                            <td className={item.type==='error'?"text-capitalize text-danger":"text-capitalize"}>{item.message}</td>
                             </tr>)  
                          })
                        }
                        

                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph
                  className="w-100 admin-placeholder"
                  rowHeight={30}
                  rowSpacing={5}
                  active={true}
                  rows={7}
                />
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() => navigate("/admin/pending-appointments/list/1")}
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingAppointmentLogsView;
